$(document).ready(function() {
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementTop > viewportTop && elementTop < viewportBottom;
  };

  //zarovnani hover modalu v Products>Availability>Large.blade.php
  AdjustDeliveryModal = function (modal) {
    //priklad: stranka ma width 1000px a div vyleza ven:
    // offset.left = kolik px je div vzdaleny od leveho okraje stranky
    // modal.outerWidth = velikost divu vcetne paddingu (300px + 2*16px = 332px)
    // whiteBorderLeft = pri rozliseni nad 1140px jsou to prazdne okraje (napr pri rozliseni 1200px je to 60px dohromady na obou stranach => leva strana je 30px)
    // documentWidth =  window.width() =  sirka cele stranky vcetne 2*whiteBorderLeft
    // pagePadding = pri rozliseni <1200px ma stranka na obou stranach padding 12px
    // offsetRight = vysledek = o kolik px div presahuje pravy okraj stranky

    var maxWebContentWidth = 1140;
    var pagePadding = 12;
    var whiteBorderLeft = 0;
    var documentWidth = $(window).width();

    if (!$(modal).children('.partials-product-availability-modal__js-arrow').length) {
      $(modal).append("<div class='partials-product-availability-modal__js-arrow' style=margin-left:" + 0 + "px;></div>");
    }

    //reset margin-left pri opetovem hoveru
    $(modal).css("margin-left", "");
    $(modal).children('.partials-product-availability-modal__js-arrow').css('margin-left', 0 + "px");
    $(modal).css("border-bottom-left-radius", "0px");

    if (documentWidth > 340) {
      if (documentWidth > 1200) {
        pagePadding = 0;
      }

      if (documentWidth > maxWebContentWidth) {
        whiteBorderLeft = (documentWidth - maxWebContentWidth) / 2;
        documentWidth = maxWebContentWidth;
      }

      var offset = modal.offset();
      var offsetRight = (offset.left + $(modal).outerWidth() + pagePadding - (whiteBorderLeft + documentWidth));

      if (offsetRight > 0) {
        $(modal).css("margin-left", -offsetRight + "px");
        $(modal).css("border-bottom-left-radius", "4px");
        $(modal).children('.partials-product-availability-modal__js-arrow').css('margin-left', offsetRight + "px");
      }
    }
  }

  $('.products-availability__delivery-info').on("mouseenter",
    function () {
      AdjustDeliveryModal($(this).find($('.partials-product-availability-modal')));
    }
  )

  //soucasne prepinani tabs inputů a select optionů v product\show:
  //prepinani tabs pri klikani na selectInput options
  ToggleTabs = function (target) {
    let selectedOptionValue = target[target.options.selectedIndex].value;

    for (let index = 0; index < target.length; index++) {
      $("." + target.options[index].value).removeAttr('checked');
    }
    $("." + selectedOptionValue).prop('checked', true);
  }

  $(".tabs__select").change(function (event) {
    ToggleTabs(event.target);
  });


  //prepinani selectInputů pri klikani na tabs   <-- nefunguje se selectInput, protoze logika selectInput funguje jinak
  ToggleSelect = function (target) {
    $(".tabs__select > option").each(function () {
      $(this).removeAttr('selected');
    });
    let optionValueName = getOptionValueName(target.className, 'option-');

    $(".tabs__select > option").each(function () {
      if ($(this).val() == optionValueName) {
        $(this).attr('selected',true);
        $(this).prop('selected',true);
      }
    });

  }

  getOptionValueName = function (radioInputClass, optionNameSubstring) {
    let optionNameStartIndex = radioInputClass.indexOf(optionNameSubstring);
    let optionValueNameString = radioInputClass.slice(optionNameStartIndex);
    return optionValueNameString.split(' ')[0];
  }

  $(".tabs__radio-input").change(function (event) {
    ToggleSelect(event.target);
  });

  //odkazy na recenze na product show
  $(document).on('click', 'a.review-inline--eshop', function(){
    $('div.option[v="option-review-eshop"]').trigger('click');
    $('.SelectInput .open').removeClass('open');
  });

  $(document).on('click', 'a.review-inline--product', function(){
    $('div.option[v="option-review-product"]').trigger('click');
    $('.SelectInput .open').removeClass('open');
  });

  $(document).on('click', 'a.open-contact', function(){
    $('div.option[v="option-contact"]').trigger('click');
    $('.SelectInput .open').removeClass('open');
  });

  //zobrazeni vysledku 4 druhu fullTextSearche:
  //Container divs: header-search, header-search-phone, index-search, configurator
  //Suggestions IDs: #suggestionsHeadSearch, #suggestionsHeadPhoneSearch, #suggestionIndex, #suggestionConfigurator
  //+
  //zobrazeni vysledku vyhledavace tiskaren v "moje_tiskarny":
  //Container: printer-configurator
  //Suggestions ID: search-result-suggestions
  ToggleSuggestions = function (container, suggestionsId, target) {
    if (target == $("." + container + " form input[type='text']")[0]) {
      $("#" + suggestionsId).removeClass("hidden");
    }
    //console.log(target.nodeName, target, $("." + container + " form input[type='text']")[0]);
    //console.log($(target).parents("." + container).length);

    if ($(target).parents("." + container).length != 1) {
      $("#" + suggestionsId).addClass("hidden");
    }
  }

  $(document).click(function (event) {
    ToggleSuggestions('header-search', 'suggestionsHeadSearch', event.target);
    ToggleSuggestions('header-search-phone', 'suggestionsHeadPhoneSearch', event.target);
    ToggleSuggestions('index-search', 'suggestionIndex', event.target);
    ToggleSuggestions('configurator', 'suggestionConfigurator', event.target);
    ToggleSuggestions('printer-search', 'search-result-suggestions', event.target);
  });


  //pridani rozmazani na zacatek a konec scroll-blur divu, pokud neni scrollnuty "nadoraz"
  var scrollBlurDivs = [...document.querySelectorAll('.scroll-blur')];

  scrollBlurDivs.forEach((item, i) => {
    scrollBlurToggle(item);
  });

  scrollBlurDivs.forEach((item, i) => {
      item.addEventListener('scroll', () => {
          scrollBlurToggle(item);
      });
  });

  $( document ).on( "ajaxComplete", function() {
      var scrollBlurDivs = [...document.querySelectorAll('.scroll-blur')];

      scrollBlurDivs.forEach((item, i) => {
        scrollBlurToggle(item);
      });

      scrollBlurDivs.forEach((item, i) => {
        item.addEventListener('scroll', () => {
            scrollBlurToggle(item);
        });
    });
  });

  function scrollBlurToggle(el) {
      var totalScrollableContentHeight = el.scrollHeight;
      var visibleContentHeight = el.clientHeight;
      var isScrollable = totalScrollableContentHeight > visibleContentHeight;
      if (!isScrollable) {
          el.classList.remove('scroll-blur--top', 'scroll-blur--bottom');
          return;
      }
      var isScrolledToBottom = el.scrollHeight < el.clientHeight + el.scrollTop + 1;
      var isScrolledToTop = isScrolledToBottom ? false : el.scrollTop === 0;
      //console.log(visibleContentHeight, totalScrollableContentHeight, isScrollable, isScrolledToBottom, isScrolledToTop);
      el.classList.toggle('scroll-blur--bottom', !isScrolledToBottom);
      el.classList.toggle('scroll-blur--top', !isScrolledToTop);
  }

  global.jsAddBefore = function(key){
    let newElement = $(key).parent().parent().find("input").first().clone().removeAttr("value");
    newElement[0].value = "";
    $(key).parent().before(newElement);
  }

  $(document).on("click", "button.jsAddBefore", function(e) {
    e.preventDefault();
    jsAddBefore(this);
  });

  global.jsToggle = function(key) {
    if ($(key).attr("jstarget") !== undefined)
      var target = $(key).attr("jstarget");
    else
      var target = $(key)
        .parents(".jsToggle")
        .first()
        .attr("jstarget");

    if ($(key).attr("jsclose") !== undefined)
      var close = $(key)
        .attr("jsclose")
        .split(" ");
    else if (
      $(key)
        .parents(".jsToggle")
        .first()
        .attr("jsclose") !== undefined
    )
      var close = $(key)
        .parents(".jsToggle")
        .first()
        .attr("jsclose")
        .split(" ");
    if (close !== undefined && close[0] !== "") {
      $.each(close, function(index, value) {
        $("." + value).each(function(index) {
          if ($(this).hasClass("hidden")) $(this).hide();
          else $(this).show();
        });
      });
    }
    var _this = key;
    $("." + target).each(function(index) {
      if ($(this).hasClass("jsToggle--width")) {
        $(this).toggleClass("jsToggle--width-active");
      } else {
        if ($(this).is("div") || $(this).is("ul")) {
          $(this).slideToggle($(_this).hasClass("jsToggle-instant") ? 10 : 500);
        } else {
          $(this).toggle(0);
        }
      }
    });
  };

  $(document).on("click", "a.jsToggle,form.jsToggle button", function(e) {
    e.preventDefault();
    jsToggle(this);
  });

  $(document).on("click", "input.jsToggle", function(e) {
    //RADIO buttony ošetření aby fungovaly jako switch (pomocí sudých a lichých čísel)
    /*if($(this).hasClass("radio")) Do pásky... co to je?
    {
        if($(this).val() < 1 || $(this).val() > 2)return false;
        var mod = parseInt($(this).val() % 2);
        $('input[name='+$(this).attr("name")+']')
        .each(function() {
            if(mod)
            {
                this.value = parseInt(this.value) + 2;
            }
            else
            {
                this.value = parseInt(this.value) - 2;
            }
        })
    }*/
    if ($(this).attr("jstarget") !== undefined)
      var target = $(this).attr("jstarget");
    else
      var target = $(this)
        .parents(".jsToggle")
        .first()
        .attr("jstarget");

    if ($(this).attr("jsclose") !== undefined)
      var close = $(this)
        .attr("jsclose")
        .split(" ");
    else if (
      $(this)
        .parents(".jsToggle")
        .first()
        .attr("jsclose") !== undefined
    )
      var close = $(this)
        .parents(".jsToggle")
        .first()
        .attr("jsclose")
        .split(" ");
    if (close !== undefined && close[0] !== "") {
      $.each(close, function(index, value) {
        $("." + value).each(function(index) {
          if ($(this).hasClass("hidden")) $(this).hide();
          else $(this).show();
        });
      });
    }
    var _this = this;
    $("." + target).each(function(index) {
      if ($(this).is("div") || $(this).is("ul")) {
        $(this).slideToggle($(_this).hasClass("jsToggle-instant") ? 10 : 500);
      } else {
        $(this).toggle(0);
      }
    });
  });

  $(document).on("keyup", function(evt) {
    if (evt.keyCode == 27) {
      $(".evt-esc").each(function() {
        $(this).addClass("hidden");
      });
      var modal = $("#component-Models-TaxDocuments-Basket-1 .modal-menu")
        .first()
        .data("Modal");
      if (modal) modal.close();
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest(".modal-content.basket").length) {
      var modal = $("#component-Models-TaxDocuments-Basket-1 .modal-menu")
        .first()
        .data("Modal");
      if (modal) modal.close();
    }
  });

  //přepnutí modalu z css na javascript
  $(".modal-menu-nojs")
    .removeClass("modal-menu-nojs")
    .addClass("modal-menu");


  //Touch screens fix - vypnutí modálů na touchscreenu
  $(".touch-modal-off .modal-menu").each(function() {
    if(typeof window.ontouchstart !== 'undefined') {
        $(this).removeClass('modal-menu');
    }
  });

    //tlačítko zpět v basket modalu
    $(document).on("click", ".dropdown-menu-basket__btn-close", function(e) {
        e.preventDefault();
        $('.dropdown-menu--basket').addClass('hover-off');
    });
    $(document).on("mouseover", ".dropdown-menu--basket", function() {
      $('.dropdown-menu--basket').removeClass('hover-off');
    });

  $(".deferimg").each(function() {
    $(this).replaceWith(
      this.innerHTML.replace("&lt;img", "<img").replace("&gt;", ">")
    );
  });

  //pokud dojde ke zmene orientationchange nebo zmene size
  //zkontroluj zda prvek neni viditelny
  $(window).on("resize", function() {
    $(document).scroll();
  });
});
